import React from 'react';

const AboutPage = () => {
  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title"
        style={{ backgroundImage: 'url(/assets/images/background/page-title.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer">
            <h1 className="title">About Us</h1>
            <ul className="page-breadcrumb">
              <li><a href="/">Home</a></li>
              <li><a href="/">Pages</a></li>
              <li>About</li>
            </ul>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="auto-container">
          <div className="row">
            <div className="content-column col-xl-6 col-lg-7 col-md-12 col-sm-12 order-2 wow fadeInRight" data-wow-delay="600ms">
              <div className="inner-column">
                <div className="sec-title">
                  <span className="sub-title">About our company</span>
                  <h2>Immigration Services From Experienced Lawyers.</h2>
                  <h4>Canada Based Immigration Consultant Agency.</h4>
                  <div className="text">
                    Web designing in a powerful way of just not an only professions, however, in a passion for our Company.
                    We have to a tendency to believe the idea that smart looking of any website is the first impression on visitors.
                  </div>
                </div>

                <div className="row">
                  <div className="about-block col-lg-6 col-md-6">
                    <div className="inner">
                      <i className="icon flaticon-worldwide"></i>
                      <h5 className="title">Best Immigration<br />Resources</h5>
                    </div>
                  </div>

                  <div className="about-block col-lg-6 col-md-6">
                    <div className="inner">
                      <i className="icon flaticon-passport-16"></i>
                      <h5 className="title">Return Visas <br />Availabile</h5>
                    </div>
                  </div>
                </div>

                <div className="btm-box">
                  <a href="page-about.html" className="theme-btn btn-style-one">
                    <span className="btn-title">Explore now</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="image-column col-xl-6 col-lg-5 col-md-12 col-sm-12">
              <div className="inner-column wow fadeInLeft">
                <figure className="image-1 overlay-anim wow fadeInUp"><img src="/assets/images/resource/about-1.jpg" alt="" /></figure>
                <figure className="image-2 overlay-anim wow fadeInRight"><img src="/assets/images/resource/about-2.jpg" alt="" /></figure>
                <figure className="image-3 overlay-anim wow fadeInLeft"><img src="/assets/images/resource/about-3.jpg" alt="" /></figure>
                <figure className="stemp"><img src="/assets/images/resource/stemp.png" alt="" /></figure>
                <div className="experience bounce-y">
                  <div className="inner">
                    <i className="icon flaticon-increase"></i>
                    <div className="text"><strong>36+</strong> Work Experience</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Countries Section */}
      <section className="countries-section">
        <div className="auto-container">
          <div className="bg-layer"></div>
          <div className="sec-title text-center light">
            <span className="sub-title">Countries we offer</span>
            <h2>Countries We Support <br />for Immigration.</h2>
          </div>

          <div className="row">
            {[
              { img: 'country-4.jpg', flag: 'flag-la.jpg', title: 'Los Angeles' },
              { img: 'country-5.jpg', flag: 'flag-in.jpg', title: 'India' },
              { img: 'country-1.jpg', flag: 'flag-aus.jpg', title: 'Australia' },
              { img: 'country-2.jpg', flag: 'flag-usa.jpg', title: 'United States' },
              { img: 'country-3.jpg', flag: 'flag-dub.jpg', title: 'Dubai' },
              { img: 'country-1.jpg', flag: 'flag-aus.jpg', title: 'Australia' },
              { img: 'country-2.jpg', flag: 'flag-usa.jpg', title: 'United States' },
              { img: 'country-3.jpg', flag: 'flag-dub.jpg', title: 'Dubai' },
            ].map((country, index) => (
              <div className="country-block col-lg-3 col-md-4 col-sm-12" key={index}>
                <div className="inner-box">
                  <div className="image-box">
                    <figure className="image">
                      <a href={`/assets/images/resource/${country.img}`} className="lightbox-image">
                        <img src={`/assets/images/resource/${country.img}`} alt={country.title} />
                      </a>
                    </figure>
                  </div>
                  <div className="content-box text-center">
                    <div className="flag">
                      <img src={`/assets/images/resource/${country.flag}`} alt="flag" />
                    </div>
                    <h5 className="title">{country.title}</h5>
                    <div className="text">Fusce pretium sem ism the eget mattis.</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutPage;